export const ONCOLOGY = 'Онкология'
export const CARDIOVASCULAR_DISEASES = 'ССЗ'

export const PROFILES = [ONCOLOGY, CARDIOVASCULAR_DISEASES]
